export const SELECTED_GROUP = 'SELECTED_GROUP';
export const UPDATE_MEMBER_ID = 'UPDATE_MEMBER_ID';
export const UPDATE_TICKET_GROUP_LIST = 'UPDATE_TICKET_GROUP_LIST';